// extracted by mini-css-extract-plugin
export var container = "_78-0";
export var error = "_78-9";
export var label = "_78-5";
export var light = "_78-6";
export var md = "_78-3";
export var sm = "_78-2";
export var thin = "_78-8";
export var thinBold = "_78-7";
export var vertical = "_78-4";
export var xs = "_78-1";